module.exports = __webpack_public_path__ + "img/market-activity-08.a57b6e00.jpg";